import { Buffer } from 'buffer';

export const convertBase64ToFile = (base64String: string) => {
  const matches = base64String.match(/^data:(.*);base64,(.*)$/);
  if (!matches) return;

  const contentType = matches[1];
  const base64Data = matches[2];

  const buffer = Buffer.from(base64Data, 'base64');
  return new File([buffer], 'image.jpg', { type: contentType });
};

export const generateGuid = (): string => {
  const generateSegment = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };

  const guid =
    generateSegment() +
    generateSegment() +
    '-' +
    generateSegment() +
    '-' +
    generateSegment() +
    '-' +
    generateSegment() +
    '-' +
    generateSegment() +
    generateSegment() +
    generateSegment();

  return guid;
};
